var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5AxSingleTridem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3060.4 803.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193{stroke-width:0px;}.cls-2,.cls-190{fill:#414042;}.cls-3{fill:url(#New_Gradient_Swatch_4);}.cls-4{fill:url(#New_Gradient_Swatch_3);}.cls-5{fill:url(#New_Gradient_Swatch_3-3);}.cls-6{fill:url(#New_Gradient_Swatch_3-4);}.cls-7{fill:url(#New_Gradient_Swatch_3-9);}.cls-8{fill:url(#New_Gradient_Swatch_3-8);}.cls-9{fill:url(#New_Gradient_Swatch_3-7);}.cls-10{fill:url(#New_Gradient_Swatch_3-6);}.cls-11{fill:url(#New_Gradient_Swatch_3-2);}.cls-12{fill:url(#New_Gradient_Swatch_3-5);}.cls-13{fill:url(#New_Gradient_Swatch_4-3);}.cls-14{fill:url(#New_Gradient_Swatch_4-2);}.cls-15{fill:url(#New_Gradient_Swatch_4-4);}.cls-16{fill:url(#New_Gradient_Swatch_4-5);}.cls-17,.cls-188{fill:#f7941d;}.cls-18{fill:url(#linear-gradient-120);}.cls-19{fill:url(#linear-gradient-125);}.cls-20{fill:url(#linear-gradient-126);}.cls-21{fill:url(#linear-gradient-138);}.cls-22{fill:url(#linear-gradient-139);}.cls-23{fill:url(#linear-gradient-134);}.cls-24{fill:url(#linear-gradient-131);}.cls-25{fill:url(#linear-gradient-136);}.cls-26{fill:url(#linear-gradient-132);}.cls-27{fill:url(#linear-gradient-135);}.cls-28{fill:url(#linear-gradient-130);}.cls-29{fill:url(#linear-gradient-133);}.cls-30{fill:url(#linear-gradient-137);}.cls-31{fill:url(#linear-gradient-100);}.cls-32{fill:url(#linear-gradient-101);}.cls-33{fill:url(#linear-gradient-123);}.cls-34{fill:url(#linear-gradient-129);}.cls-35{fill:url(#linear-gradient-121);}.cls-36{fill:url(#linear-gradient-122);}.cls-37{fill:url(#linear-gradient-109);}.cls-38{fill:url(#linear-gradient-108);}.cls-39{fill:url(#linear-gradient-106);}.cls-40{fill:url(#linear-gradient-107);}.cls-41{fill:url(#linear-gradient-102);}.cls-42{fill:url(#linear-gradient-104);}.cls-43{fill:url(#linear-gradient-103);}.cls-44{fill:url(#linear-gradient-105);}.cls-45{fill:url(#linear-gradient-117);}.cls-46{fill:url(#linear-gradient-118);}.cls-47{fill:url(#linear-gradient-111);}.cls-48{fill:url(#linear-gradient-112);}.cls-49{fill:url(#linear-gradient-127);}.cls-50{fill:url(#linear-gradient-128);}.cls-51{fill:url(#linear-gradient-110);}.cls-52{fill:url(#linear-gradient-113);}.cls-53{fill:url(#linear-gradient-116);}.cls-54{fill:url(#linear-gradient-119);}.cls-55{fill:url(#linear-gradient-144);}.cls-56{fill:url(#linear-gradient-145);}.cls-57{fill:url(#linear-gradient-146);}.cls-58{fill:url(#linear-gradient-143);}.cls-59{fill:url(#linear-gradient-140);}.cls-60{fill:url(#linear-gradient-141);}.cls-61{fill:url(#linear-gradient-142);}.cls-194{mask:url(#mask);}.cls-62{fill:#fff;}.cls-62,.cls-67,.cls-158,.cls-195,.cls-167,.cls-170,.cls-171,.cls-173,.cls-174,.cls-184,.cls-185,.cls-186,.cls-188,.cls-190,.cls-192{mix-blend-mode:multiply;}.cls-63,.cls-170{fill:#ed1c24;}.cls-196{filter:url(#luminosity-noclip);}.cls-64{fill:#ef4136;}.cls-65{fill:#6d6e71;}.cls-66{fill:#f15a29;}.cls-67{fill:url(#linear-gradient);}.cls-68{fill:url(#linear-gradient-38);}.cls-69{fill:url(#linear-gradient-33);}.cls-70{fill:url(#linear-gradient-29);}.cls-71{fill:url(#linear-gradient-32);}.cls-72{fill:url(#linear-gradient-30);}.cls-73{fill:url(#linear-gradient-31);}.cls-74{fill:url(#linear-gradient-36);}.cls-75{fill:url(#linear-gradient-39);}.cls-76{fill:url(#linear-gradient-34);}.cls-77{fill:url(#linear-gradient-37);}.cls-78{fill:url(#linear-gradient-35);}.cls-79{fill:url(#linear-gradient-28);}.cls-80{fill:url(#linear-gradient-25);}.cls-81{fill:url(#linear-gradient-11);}.cls-82{fill:url(#linear-gradient-12);}.cls-83{fill:url(#linear-gradient-13);}.cls-84{fill:url(#linear-gradient-10);}.cls-85{fill:url(#linear-gradient-17);}.cls-86{fill:url(#linear-gradient-16);}.cls-87{fill:url(#linear-gradient-19);}.cls-88{fill:url(#linear-gradient-15);}.cls-89{fill:url(#linear-gradient-23);}.cls-90{fill:url(#linear-gradient-21);}.cls-91{fill:url(#linear-gradient-18);}.cls-92{fill:url(#linear-gradient-14);}.cls-93{fill:url(#linear-gradient-22);}.cls-94{fill:url(#linear-gradient-20);}.cls-95{fill:url(#linear-gradient-27);}.cls-96{fill:url(#linear-gradient-24);}.cls-97{fill:url(#linear-gradient-26);}.cls-98{fill:url(#linear-gradient-45);}.cls-99{fill:url(#linear-gradient-46);}.cls-100{fill:url(#linear-gradient-44);}.cls-101{fill:url(#linear-gradient-48);}.cls-102{fill:url(#linear-gradient-49);}.cls-103{fill:url(#linear-gradient-47);}.cls-104{fill:url(#linear-gradient-42);}.cls-105{fill:url(#linear-gradient-43);}.cls-106{fill:url(#linear-gradient-40);}.cls-107{fill:url(#linear-gradient-41);}.cls-108{fill:url(#linear-gradient-59);}.cls-109{fill:url(#linear-gradient-57);}.cls-110{fill:url(#linear-gradient-58);}.cls-111{fill:url(#linear-gradient-55);}.cls-112{fill:url(#linear-gradient-56);}.cls-113{fill:url(#linear-gradient-53);}.cls-114{fill:url(#linear-gradient-51);}.cls-115{fill:url(#linear-gradient-52);}.cls-116{fill:url(#linear-gradient-50);}.cls-117{fill:url(#linear-gradient-54);}.cls-118{fill:url(#linear-gradient-60);}.cls-119{fill:url(#linear-gradient-61);}.cls-120{fill:url(#linear-gradient-62);}.cls-121{fill:url(#linear-gradient-65);}.cls-122{fill:url(#linear-gradient-79);}.cls-123{fill:url(#linear-gradient-78);}.cls-124{fill:url(#linear-gradient-77);}.cls-125{fill:url(#linear-gradient-75);}.cls-126{fill:url(#linear-gradient-76);}.cls-127{fill:url(#linear-gradient-74);}.cls-128{fill:url(#linear-gradient-67);}.cls-129{fill:url(#linear-gradient-68);}.cls-130{fill:url(#linear-gradient-66);}.cls-131{fill:url(#linear-gradient-63);}.cls-132{fill:url(#linear-gradient-69);}.cls-133{fill:url(#linear-gradient-64);}.cls-134{fill:url(#linear-gradient-71);}.cls-135{fill:url(#linear-gradient-72);}.cls-136{fill:url(#linear-gradient-70);}.cls-137{fill:url(#linear-gradient-73);}.cls-138{fill:url(#linear-gradient-84);}.cls-139{fill:url(#linear-gradient-85);}.cls-140{fill:url(#linear-gradient-82);}.cls-141{fill:url(#linear-gradient-83);}.cls-142{fill:url(#linear-gradient-89);}.cls-143{fill:url(#linear-gradient-88);}.cls-144{fill:url(#linear-gradient-86);}.cls-145{fill:url(#linear-gradient-87);}.cls-146{fill:url(#linear-gradient-80);}.cls-147{fill:url(#linear-gradient-81);}.cls-148{fill:url(#linear-gradient-98);}.cls-149{fill:url(#linear-gradient-91);}.cls-150{fill:url(#linear-gradient-92);}.cls-151{fill:url(#linear-gradient-93);}.cls-152{fill:url(#linear-gradient-90);}.cls-153{fill:url(#linear-gradient-96);}.cls-154{fill:url(#linear-gradient-97);}.cls-155{fill:url(#linear-gradient-94);}.cls-156{fill:url(#linear-gradient-95);}.cls-157{fill:url(#linear-gradient-99);}.cls-158,.cls-166,.cls-175{fill:#000;}.cls-159{fill:#f1f2f2;}.cls-160{fill:#58595b;}.cls-161,.cls-171{fill:#bcbec0;}.cls-162,.cls-167{fill:#808285;}.cls-163{fill:url(#New_Gradient_Swatch_3-12);}.cls-164{fill:url(#New_Gradient_Swatch_3-11);}.cls-165{fill:url(#New_Gradient_Swatch_3-10);}.cls-168,.cls-173{fill:#a7a9ac;}.cls-169{fill:url(#New_Gradient_Swatch_11_cop);}.cls-172{fill:#be1e2d;}.cls-174,.cls-189{fill:#e6e7e8;}.cls-175{opacity:.5;}.cls-176{fill:url(#linear-gradient-4);}.cls-177{fill:url(#linear-gradient-2);}.cls-178{fill:url(#linear-gradient-3);}.cls-179{fill:url(#linear-gradient-8);}.cls-180{fill:url(#linear-gradient-9);}.cls-181{fill:url(#linear-gradient-7);}.cls-182{fill:url(#linear-gradient-5);}.cls-183{fill:url(#linear-gradient-6);}.cls-184{fill:url(#linear-gradient-115);}.cls-185{fill:url(#linear-gradient-114);}.cls-186{fill:url(#linear-gradient-124);}.cls-187,.cls-192{fill:#939598;}.cls-197{isolation:isolate;}.cls-191{fill:#d1d3d4;}.cls-193{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 2.43,
    y: 716.11,
    width: 3055.54,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 2.43,
    y: 716.11,
    width: 3055.54,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3057,
    height: 88,
    transform: "translate(1.7 715.91)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1893.78,
    y1: 540.94,
    x2: 1893.78,
    y2: 457.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#545152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1267.93,
    y1: 670.46,
    x2: 1267.93,
    y2: 514.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 1267.93,
    y1: 683.23,
    x2: 1267.93,
    y2: 691.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    y1: 651.72,
    y2: 682.75,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    y1: 495.78,
    y2: 636.74,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 2636.16,
    y1: 717.26,
    x2: 2636.16,
    y2: 530.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 2636.16,
    y1: 547.37,
    x2: 2636.16,
    y2: 706.15,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2636.16,
    y1: 682.04,
    x2: 2636.16,
    y2: 567.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2636.13,
    y1: 573.42,
    x2: 2636.13,
    y2: 673.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2636.16,
    y1: 642.51,
    x2: 2636.16,
    y2: 605.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2636.16,
    y1: 637.62,
    x2: 2636.16,
    y2: 611,
    gradientTransform: "translate(2637.89 -2084.94) rotate(76.72)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2756.57,
    y1: 542.49,
    x2: 2756.57,
    y2: 462.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8d8f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6c6d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#545456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2749.62,
    x2: 2749.62,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2763.51,
    x2: 2763.51,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2976.21,
    x2: 2976.21,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2990.1,
    x2: 2990.1,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 2876.97,
    x2: 2876.97,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 2876.97,
    y1: 547.37,
    x2: 2876.97,
    y2: 706.15,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2876.97,
    x2: 2876.97,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2876.94,
    x2: 2876.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2876.97,
    x2: 2876.97,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2876.97,
    y1: 637.62,
    x2: 2876.97,
    y2: 611,
    gradientTransform: "translate(137.12 -452.79) rotate(9.22)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2285.2,
    x2: 2285.2,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2285.2,
    x2: 2285.2,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2278.25,
    x2: 2278.25,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2292.14,
    x2: 2292.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2515.78,
    x2: 2515.78,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2515.78,
    x2: 2515.78,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2508.84,
    x2: 2508.84,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2522.73,
    x2: 2522.73,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 2395.41,
    x2: 2395.41,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 2395.41,
    y1: 547.37,
    x2: 2395.41,
    y2: 706.15,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2395.41,
    x2: 2395.41,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2395.38,
    x2: 2395.38,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2395.41,
    x2: 2395.41,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2395.41,
    y1: 637.62,
    x2: 2395.41,
    y2: 611,
    gradientTransform: "translate(421.17 -869.18) rotate(22.5)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -4144.23,
    y1: 448.98,
    x2: -4144.23,
    y2: 352.66,
    gradientTransform: "translate(-3630.21) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b7b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -4106.81,
    y1: 490.28,
    x2: -4106.81,
    y2: 311.6,
    gradientTransform: "translate(-3630.21) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -4085.33,
    y1: 308.6,
    x2: -4085.33,
    y2: 493.09,
    gradientTransform: "translate(-3630.21) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 308.61,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 308.61,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 308.61,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 308.61,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 308.62,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 618.35) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 308.62,
    y2: 493.1,
    gradientTransform: "translate(4540.45 623.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 308.62,
    y2: 493.08,
    gradientTransform: "translate(4540.45 629.87) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 308.62,
    y2: 493.08,
    gradientTransform: "translate(4540.45 637.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 646.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 308.62,
    y2: 493.08,
    gradientTransform: "translate(4540.45 656.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 667.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 679.87) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 308.62,
    y2: 493.08,
    gradientTransform: "translate(4540.45 693.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 707.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 721.94) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    y1: 308.62,
    y2: 493.08,
    gradientTransform: "translate(4540.45 737.24) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 753.27) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 769.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 785.95) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    y1: 308.62,
    y2: 493.09,
    gradientTransform: "translate(4540.45 801.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -4128.3,
    x2: -4128.3,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -4128.3,
    y1: 308.61,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -4128.3,
    y1: 308.61,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -4128.3,
    y1: 308.61,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -4128.3,
    y1: 308.61,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 618.35) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.1,
    gradientTransform: "translate(4626.39 623.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.08,
    gradientTransform: "translate(4626.39 629.87) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.08,
    gradientTransform: "translate(4626.39 637.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 646.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.08,
    gradientTransform: "translate(4626.39 656.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 667.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 679.87) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.08,
    gradientTransform: "translate(4626.39 693.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 707.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 721.94) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.08,
    gradientTransform: "translate(4626.39 737.24) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 753.27) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 769.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 785.95) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -4128.3,
    y1: 308.62,
    x2: -4128.3,
    y2: 493.09,
    gradientTransform: "translate(4626.39 801.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -4106.81,
    y1: 310.12,
    x2: -4106.81,
    y2: 493.58,
    gradientTransform: "translate(4583.42 801.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 261.18,
    y1: 716.98,
    x2: 261.18,
    y2: 529.77,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 261.18,
    y1: 547.09,
    x2: 261.18,
    y2: 705.87,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 261.18,
    y1: 573.93,
    x2: 261.18,
    y2: 673.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    y1: 653.65,
    y2: 593.46,
    gradientTransform: "translate(253.38 -52.42) rotate(22.06)",
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 261.18,
    y1: 681.76,
    x2: 261.18,
    y2: 566.79,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 261.18,
    y1: 607.4,
    x2: 261.18,
    y2: 641.88,
    gradientTransform: "translate(517.6 -1.97) rotate(45)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 261.18,
    y1: 637.46,
    x2: 261.18,
    y2: 610.61,
    gradientTransform: "translate(517.6 -1.97) rotate(45)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 628.74,
    y1: 533.8,
    x2: 628.74,
    y2: 635.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 560.5,
    y1: 622.74,
    x2: 560.5,
    y2: 641.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 628.74,
    x2: 628.74,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 696.98,
    x2: 696.98,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 648.87,
    y1: 540.32,
    x2: 673.27,
    y2: 540.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 985.06,
    y1: 716.98,
    x2: 985.06,
    y2: 529.77,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 985.06,
    y1: 547.09,
    x2: 985.06,
    y2: 705.87,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 985.06,
    y1: 681.76,
    x2: 985.06,
    y2: 566.79,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 985.03,
    y1: 573.14,
    x2: 985.03,
    y2: 673.38,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 985.06,
    y1: 642.23,
    x2: 985.06,
    y2: 604.98,
    gradientTransform: "translate(729.62 -513.83) rotate(45)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 985.06,
    y1: 637.34,
    x2: 985.06,
    y2: 610.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 478.29,
    y1: 372.62,
    x2: 478.29,
    y2: 503.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 414.15,
    y1: 568.6,
    x2: 414.15,
    y2: 487.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 271.12,
    y1: -903.46,
    x2: 271.12,
    y2: -985.02,
    gradientTransform: "translate(701.57 -388.24) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 130.93,
    y1: -850.49,
    x2: 130.93,
    y2: -782.66,
    gradientTransform: "translate(561.38 -275.7) rotate(-180)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 130.93,
    y1: -790.44,
    x2: 130.93,
    y2: -843.52,
    gradientTransform: "translate(1255.94 483.4) rotate(-103.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 130.93,
    y1: -837.77,
    x2: 130.93,
    y2: -795.79,
    gradientTransform: "translate(561.38 -275.7) rotate(-180)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 130.93,
    y1: -800.6,
    x2: 130.93,
    y2: -833.45,
    gradientTransform: "translate(561.38 -275.7) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 156.37,
    y1: 373.02,
    x2: 156.37,
    y2: 261.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 303.58,
    y1: 373.02,
    x2: 303.58,
    y2: 261.18,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1716.99,
    y1: 502.52,
    x2: 1716.99,
    y2: 549.38,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 2080.84,
    y1: -2994.99,
    x2: 2080.84,
    y2: -2976.55,
    gradientTransform: "translate(5137.07 -2448.36) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1737.94,
    y1: 505.05,
    x2: 1737.94,
    y2: 525.05,
    gradientTransform: "translate(1318.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1720.36,
    y1: 479.38,
    x2: 1720.36,
    y2: 549.13,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 1728.36,
    y1: 458.4,
    x2: 1728.36,
    y2: 627.11,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1728.36,
    y1: 561.75,
    x2: 1728.36,
    y2: 628.45,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1896.25,
    y1: 1.17,
    x2: 1896.25,
    y2: 491.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 211.65,
    y1: 217.13,
    x2: 211.65,
    y2: 524.14,
    xlinkHref: "#linear-gradient-107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 109.02,
    y1: 563.68,
    x2: 109.02,
    y2: 528.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 95.53,
    y1: 623.03,
    x2: 95.53,
    y2: 630.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 31.18,
    y1: 523.99,
    x2: 31.18,
    y2: 632.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 315.85,
    y1: 373.02,
    x2: 315.85,
    y2: 261.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 315.84,
    y1: 362.24,
    x2: 315.84,
    y2: 271.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d4d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 227.39,
    y1: 435.37,
    x2: 227.39,
    y2: 419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 207.85,
    y1: 423.78,
    x2: 207.85,
    y2: 430.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 245.43,
    x2: 245.43,
    xlinkHref: "#linear-gradient-125"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 226.64,
    y1: 424.73,
    x2: 226.64,
    y2: 429.87,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 83.55,
    y1: 503.83,
    x2: 83.55,
    y2: 515.01,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 7.62,
    y1: 360.24,
    x2: 18.41,
    y2: 392.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 12.87,
    y1: 264.55,
    x2: 12.87,
    y2: 355.81,
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1490.31,
    y1: 666.29,
    x2: 1490.31,
    y2: 605.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1784.17,
    x2: 1784.17,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 2078.02,
    x2: 2078.02,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1637.24,
    y1: 662.69,
    x2: 1637.24,
    y2: 494.97,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1931.09,
    y1: 662.69,
    x2: 1931.09,
    y2: 494.97,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -4274.11,
    y1: 612.6,
    x2: -4274.11,
    gradientTransform: "translate(-2489.95) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -4274.11,
    y1: 558.92,
    x2: -4274.11,
    y2: 551.73,
    gradientTransform: "translate(-2489.95) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -4274.11,
    x2: -4274.11,
    y2: 494.97,
    gradientTransform: "translate(-2489.95) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -5135.68,
    y1: 500.41,
    x2: -5135.68,
    y2: 488.97,
    gradientTransform: "translate(8044.42 989.12) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -5150.37,
    y1: 488.86,
    x2: -5150.37,
    y2: 500.92,
    gradientTransform: "translate(8073.81 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -4421.58,
    x2: -4421.58,
    gradientTransform: "translate(6616.23 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-139"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -4436.27,
    y1: 488.86,
    x2: -4436.27,
    y2: 500.92,
    gradientTransform: "translate(6645.61 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -3707.48,
    x2: -3707.48,
    gradientTransform: "translate(5188.03 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-139"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -3722.17,
    y1: 488.86,
    x2: -3722.17,
    y2: 500.92,
    gradientTransform: "translate(5217.41 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -2993.38,
    x2: -2993.38,
    gradientTransform: "translate(3759.83 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-139"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -3008.07,
    y1: 488.86,
    x2: -3008.07,
    y2: 500.92,
    gradientTransform: "translate(3789.21 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-116"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-195",
    width: 3057,
    height: 88,
    transform: "translate(1.7 715.91)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M925.77,508.91l-27.97-22.56c-2.73-2.2-6.62-2.2-9.35,0l-27.97,22.56h-33.9c-6.33,0-11.46,5.13-11.46,11.46v11.69h147.25v-11.69c0-6.33-5.13-11.46-11.46-11.46h-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M899.88,512.99l19.11-20.59h-50.39l19.11,20.59c3.28,3.54,8.88,3.54,12.17,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "963.04 495.88 830.97 495.88 830.97 484.7 924.6 484.7 963.04 491.66 963.04 495.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 847.51,
    y: 484.7,
    width: 77.09,
    height: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M899.87,506.1c0,3.36-2.72,6.08-6.08,6.08s-6.08-2.72-6.08-6.08,2.72-6.08,6.08-6.08,6.08,2.72,6.08,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M572.98,500.58c-.57,0-1.15-.02-1.75-.06-1.1-.08-1.93-1.04-1.85-2.14.08-1.1,1.04-1.92,2.14-1.85,9.08.67,14.43-5.16,19.6-10.79,4.33-4.71,8.8-9.59,15.25-9.99,5.42-.33,8.54,3.62,10.82,6.51,1.23,1.56,2.52,3.16,3.26,2.95,2.05-.56,1.68-6.43,1.44-10.32-.33-5.28-.62-9.84,2.97-10.56,3.68-.74,5.1,3.57,6.6,8.12,1.05,3.19,2.64,8,4.52,8h0c1.17-1.1.88-5.98.71-8.9-.32-5.36-.62-10.43,3.1-11.07,3.93-.69,5.33,4.58,6.96,10.66.71,2.65,1.98,7.4,3.09,8.61.6-1.55.6-6.09.61-8.65,0-6.47.02-11.58,3.84-11.61,3.94-.09,5.17,6.12,6.7,13.26.19.9.41,1.91.63,2.87.27-1.24.53-2.59.76-3.76,1.68-8.63,2.82-13.52,6.21-13.33,3.38.16,3.53,4.61,3.77,11.33.11,3.03.3,8.46,1.14,10.07.98-1.34,2-6.02,2.57-8.65,1.23-5.67,2.09-9.21,4.23-10.41.8-.45,1.72-.52,2.59-.22,3.45,1.21,3.73,6.48,4.02,12.07.13,2.57.37,7.26,1.21,8.23.63-.41,1.78-2,2.49-2.98,2.14-2.95,4.8-6.63,8.71-5.72,3.08.72,4.62,2.67,6.12,4.56,3.08,3.89,7.3,9.22,30.61,8.47.99-.03,2.02.83,2.06,1.93.04,1.1-.83,2.03-1.93,2.06-25.34.82-30.27-5.43-33.88-9.99-1.43-1.81-2.25-2.77-3.89-3.15-1.34-.32-3.12,2.17-4.57,4.17-1.94,2.69-4.6,6.38-7.96,3.99-2.48-1.77-2.71-6.22-2.98-11.37-.12-2.35-.33-6.43-1-7.97-.71,1.51-1.46,4.96-1.93,7.17-1.38,6.34-2.68,12.34-6.8,12.02-4.33-.33-4.56-7.04-4.81-14.15-.06-1.6-.13-3.66-.28-5.29-.69,2.33-1.35,5.74-1.77,7.92-1.39,7.16-2.08,10.42-4.78,10.27-2.48-.14-3.14-3.21-4.44-9.31-.55-2.57-1.47-6.88-2.4-9.02-.23,1.76-.24,4.62-.24,6.54,0,6.24-.15,10.16-2.09,11.96-.71.66-1.59.97-2.57.9-3.81-.29-5.24-5.62-6.89-11.79-.58-2.17-1.47-5.51-2.28-7.06-.2,1.52-.03,4.35.08,6.2.29,4.9.57,9.52-1.59,11.82-.81.86-1.88,1.31-3.1,1.31h-.01c-4.76,0-6.65-5.71-8.31-10.74-.49-1.48-1.23-3.74-1.87-4.87-.19,1.38-.02,3.97.09,5.81.36,5.79.81,13-4.37,14.42-3.31.91-5.52-1.87-7.46-4.33-2.02-2.56-4.15-5.21-7.43-5-4.85.3-8.42,4.19-12.56,8.7-5.24,5.71-11.15,12.14-21.09,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M546.33,506.76c-.4,0-.81-.01-1.22-.03-1.1-.06-1.95-1-1.89-2.1.06-1.1.95-1.95,2.1-1.89,10.64.56,16.71-7.95,22.58-16.17,5.05-7.07,9.81-13.74,17.27-14.58,6.27-.71,9.98,4.66,12.71,8.57,1.4,2.01,3.13,4.5,4.04,4.17,2.76-1.03,2.08-9.75,1.63-15.53-.59-7.56-1.01-13.02,2.74-14.07,4.13-1.15,5.8,4.35,7.72,10.73,1.31,4.34,3.44,11.63,5.83,11.51.14,0,.2-.03.29-.14,1.42-1.59.89-8.67.53-13.35-.58-7.73-1.04-13.84,2.87-14.8,4.38-1.08,6.08,5.68,8.21,14.23.99,3.98,2.79,11.19,4.3,12.62.91-1.91.74-8.9.63-13.19-.23-9.32-.38-15.48,3.72-15.67,4.15-.23,5.7,6.66,7.98,17.85.36,1.76.78,3.83,1.2,5.61.36-2.17.72-4.8,1.01-7,1.68-12.5,2.71-18.5,6.43-18.42,3.65.08,3.94,5.4,4.47,15.06.25,4.64.72,13.05,2.01,15,1.28-1.69,2.35-8.71,3.01-13.02,1.26-8.27,2.09-13.02,4.55-14.45.83-.48,1.79-.56,2.7-.21,3.77,1.44,4.21,7.91,4.78,16.11.3,4.33.74,10.81,1.98,12.23.8-.68,2.12-3.12,2.94-4.63,2.42-4.47,5.43-10.03,10.2-7.94,2,.87,3.34,2.67,5.03,4.94,4.23,5.67,11.31,15.17,37.16,16.84,1.1.07,1.94,1.02,1.87,2.12-.07,1.1-1.02,1.93-2.12,1.87-27.69-1.79-35.46-12.21-40.1-18.44-1.34-1.8-2.4-3.22-3.42-3.67-1.41-.6-3.63,3.48-5.09,6.18-1.83,3.38-3.41,6.29-5.83,6.78-.74.15-1.85.13-3-.8-2.52-2.03-3.04-7.1-3.59-15.2-.26-3.7-.71-10.24-1.8-12.17-.91,1.95-1.73,7.33-2.3,11.05-1.44,9.43-2.61,16.89-7.17,16.62-4.76-.26-5.21-8.52-5.79-18.98-.16-2.89-.37-6.8-.76-9.32-.88,3.24-1.67,9.09-2.19,12.98-1.38,10.29-1.99,14.11-4.88,14.04-2.58-.09-3.3-3.04-5.2-12.38-.83-4.05-2.26-11.06-3.6-13.76-.4,2.36-.28,7.24-.2,10.69.22,8.77.23,14.27-2.06,16.49-.71.69-1.62,1.03-2.58.98-4.28-.23-5.99-7.12-8.16-15.83-.86-3.44-2.22-8.91-3.37-10.8-.46,1.97-.08,6.96.15,10.1.52,6.92,1.01,13.45-1.54,16.31-.81.91-1.89,1.42-3.12,1.47-5.45.16-7.65-7.19-9.81-14.35-.77-2.57-1.89-6.26-2.8-7.62-.45,1.76-.09,6.34.15,9.5.67,8.61,1.36,17.51-4.23,19.58-3.81,1.41-6.31-2.17-8.72-5.64-2.98-4.29-5.37-7.28-8.98-6.88-5.68.64-9.95,6.61-14.46,12.93-5.99,8.39-12.76,17.87-24.82,17.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1269.58,
    y: 473.88,
    width: 1783.93,
    height: 92.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M734.06,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.74v-83.49H734.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M734.06,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.74v-83.49H734.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1265.42,
    y: 583.16,
    width: 97.35,
    height: 11.6,
    transform: "translate(-31.57 1101.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 1256.05,
    y: 510.52,
    width: 23.76,
    height: 163.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1233.09,683.19h69.68v3.54c0,2.51-2.04,4.55-4.55,4.55h-60.58c-2.51,0-4.55-2.04-4.55-4.55v-3.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1260.34,655.93l-15.72,27.23h46.63l-15.72-27.23c-3.38-5.85-11.82-5.85-15.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M1273.18,662.9c0,2.9-2.35,5.25-5.25,5.25s-5.25-2.35-5.25-5.25,2.35-5.25,5.25-5.25,5.25,2.35,5.25,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1259.49,494.97h16.9c7.16,0,12.98,5.82,12.98,12.98v130.64h-42.86v-130.64c0-7.16,5.82-12.98,12.98-12.98Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 1257.48,
    cy: 512.29,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1281.57,530.39c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M3021.05,685.74c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2521.53,
    y: 621.38,
    width: 88.38,
    height: 8.74,
    transform: "translate(274.88 -688.23) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2745.84,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.9-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 2636.41,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-38.14 1056.42) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2636.16,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2636.16,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2728.46,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.58,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2636.16,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2636.16,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2636.16,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M2636.16,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2636.16,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M2636.16,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2636.16,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2636.13,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2603.36,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2595.32,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2614.63,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.97,3.45,11.09ZM2636,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2636.26,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2657.63,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2668.9,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2676.94,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2686.17,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2611,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2636,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2672.16,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M2600.96,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2636,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2636.13,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2603.36,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2595.32,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2614.63,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.97,3.45,11.09ZM2636,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2636.26,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2657.63,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2668.9,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2676.94,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2638.64 645.21 2634.46 645.21 2632.38 648.82 2634.46 652.44 2638.64 652.44 2640.72 648.82 2638.64 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2638.6,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2652.84 637.28 2649.89 640.23 2650.97 644.25 2655 645.33 2657.95 642.38 2656.87 638.35 2652.84 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2655.37,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2657.28 621.62 2657.28 625.79 2660.89 627.87 2664.51 625.79 2664.51 621.62 2660.89 619.53 2657.28 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-162",
    cx: 2660.89,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2649.35 607.41 2652.3 610.36 2656.33 609.28 2657.41 605.25 2654.46 602.3 2650.43 603.38 2649.35 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2651.93,604.88c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2633.69 602.97 2637.86 602.97 2639.94 599.36 2637.86 595.74 2633.69 595.74 2631.6 599.36 2633.69 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2633.73,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2619.48 610.91 2622.43 607.96 2621.35 603.93 2617.32 602.85 2614.37 605.8 2615.45 609.83 2619.48 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2616.95,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2615.04 626.56 2615.04 622.39 2611.43 620.31 2607.81 622.39 2607.81 626.56 2611.43 628.65 2615.04 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2611.43,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2622.98 640.77 2620.03 637.82 2616 638.9 2614.92 642.93 2617.87 645.88 2621.9 644.8 2622.98 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2620.39,643.3c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-182",
    cx: 2636.16,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 2636.16,
    cy: 624.09,
    r: 13.18,
    transform: "translate(1423.1 3046.35) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2762.34,
    y: 621.38,
    width: 88.38,
    height: 8.74,
    transform: "translate(284.36 -755.13) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2746.93,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2760.82,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 2746.93,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2760.82,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 2973.52,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 2987.41,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2986.65,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.9-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 2877.22,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-66.42 677.74) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2876.97,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2876.97,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2969.27,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.58,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2876.97,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2876.97,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2876.97,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M2876.97,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2876.97,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M2876.97,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2876.97,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M2876.94,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2844.17,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2836.13,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2855.44,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2876.81,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2877.07,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2898.44,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2909.71,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.09-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2917.75,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2926.98,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2851.81,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2876.81,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2912.97,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M2841.77,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.97-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2876.81,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2876.94,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2844.17,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2836.13,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2855.44,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2876.81,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2877.07,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2898.44,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2909.71,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.09-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2917.75,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2879.44 645.21 2875.27 645.21 2873.19 648.82 2875.27 652.44 2879.44 652.44 2881.53 648.82 2879.44 645.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-162",
    cx: 2877.36,
    cy: 648.82,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2893.65 637.28 2890.7 640.23 2891.78 644.25 2895.81 645.33 2898.76 642.38 2897.68 638.35 2893.65 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2896.18,639.86c.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2898.09 621.62 2898.09 625.79 2901.7 627.87 2905.32 625.79 2905.32 621.62 2901.7 619.53 2898.09 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2901.7,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2890.15 607.41 2893.1 610.36 2897.13 609.28 2898.21 605.25 2895.26 602.3 2891.23 603.38 2890.15 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2892.74,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2874.5 602.97 2878.67 602.97 2880.75 599.36 2878.67 595.74 2874.5 595.74 2872.41 599.36 2874.5 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2874.53,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2860.29 610.91 2863.24 607.96 2862.16 603.93 2858.13 602.85 2855.18 605.8 2856.26 609.83 2860.29 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2857.76,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2855.85 626.56 2855.85 622.39 2852.24 620.31 2848.62 622.39 2848.62 626.56 2852.24 628.65 2855.85 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2852.24,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2863.78 640.77 2860.83 637.82 2856.81 638.9 2855.73 642.93 2858.68 645.88 2862.71 644.8 2863.78 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2861.2,643.3c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-92",
    cx: 2876.97,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-88",
    cx: 2876.97,
    cy: 624.09,
    r: 13.18,
    transform: "translate(-62.82 468.9) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2982.37,580.58h-10.29l-16.86-36.19h43.48l-4.28,25.96c-.97,5.9-6.07,10.22-12.05,10.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2769.53 620.33 2744.22 620.33 2728.51 544.39 2782.84 544.39 2769.53 620.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-193",
    cx: 2756.06,
    cy: 567.74,
    r: 9.26,
    transform: "translate(1570.29 3119.62) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2801.49,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2966.22,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2992.42,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M2986.18,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2278.17,
    y: 621.38,
    width: 88.38,
    height: 8.74,
    transform: "translate(265.3 -620.61) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 2275.56,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 2289.45,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 2275.56,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2289.45,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 2506.15,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 2520.04,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2506.15,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2520.04,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2505.08,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.03,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.91-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 2395.65,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-58.3 297.39) rotate(-7.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2395.41,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2395.41,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2487.7,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.81-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.58,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2395.41,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2395.41,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2395.41,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2395.41,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2395.41,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M2395.41,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2395.41,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2395.38,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2362.61,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2354.57,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2373.88,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2395.25,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2395.51,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2416.88,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2428.14,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2436.19,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2445.41,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2370.25,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2395.24,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2431.41,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M2360.2,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2395.25,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2395.38,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2362.61,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2354.57,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2373.88,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2395.25,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2395.51,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2416.88,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2428.14,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2436.19,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2397.88 645.21 2393.71 645.21 2391.62 648.82 2393.71 652.44 2397.88 652.44 2399.97 648.82 2397.88 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2397.84,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2412.09 637.28 2409.14 640.23 2410.22 644.25 2414.25 645.33 2417.2 642.38 2416.12 638.35 2412.09 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2414.62,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2416.53 621.62 2416.53 625.79 2420.14 627.87 2423.75 625.79 2423.75 621.62 2420.14 619.53 2416.53 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-162",
    cx: 2420.14,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2408.59 607.41 2411.54 610.36 2415.57 609.28 2416.65 605.25 2413.7 602.3 2409.67 603.38 2408.59 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2411.17,604.88c.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2392.93 602.97 2397.1 602.97 2399.19 599.36 2397.1 595.74 2392.93 595.74 2390.85 599.36 2392.93 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2392.97,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2378.72 610.91 2381.67 607.96 2380.59 603.93 2376.56 602.85 2373.61 605.8 2374.69 609.83 2378.72 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2376.2,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2374.29 626.56 2374.29 622.39 2370.67 620.31 2367.06 622.39 2367.06 626.56 2370.67 628.65 2374.29 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2370.67,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "2382.22 640.77 2379.27 637.82 2375.24 638.9 2374.16 642.93 2377.11 645.88 2381.14 644.8 2382.22 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2379.64,643.3c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-97",
    cx: 2395.41,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-95",
    cx: 2395.41,
    cy: 624.09,
    r: 13.18,
    transform: "translate(-56.49 964.19) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2528.72 620.33 2503.41 620.33 2487.7 544.39 2542.03 544.39 2528.72 620.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-193",
    cx: 2515.25,
    cy: 567.74,
    r: 9.26,
    transform: "translate(335.25 1944.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2260.05,544.39l5.86,62.92c.69,7.38,6.88,13.02,14.29,13.02h2.92l37.08-75.94h-60.14ZM2284.82,598.82c-5.11,0-9.26-4.15-9.26-9.26s4.15-9.26,9.26-9.26,9.26,4.15,9.26,9.26-4.15,9.26-9.26,9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2319.92,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2484.66,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2510.85,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M2504.61,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2560.68,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2725.41,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2751.61,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M2745.37,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 473.08,
    y: 611.62,
    width: 516.08,
    height: 8.47,
    transform: "translate(84.31 -88.03) rotate(7.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1128.66,
    y: 578.65,
    width: 24.71,
    height: 5.1,
    transform: "translate(559.82 1722.22) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1128.66,
    y: 579.98,
    width: 24.71,
    height: 2.45,
    transform: "translate(559.82 1722.22) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1122.25,
    y: 587.04,
    width: 26.98,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1122.25,
    y: 571.22,
    width: 26.98,
    height: 4.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M513.94,362.06c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M513.94,362.06c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M504.68,458.07h0c3.04,0,5.5-2.46,5.5-5.5v-103.5c0-3.04-2.46-5.5-5.5-5.5h0v114.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M447.81,314.81l4.39-6.29h48.83l4.39,6.29c1.64,2.35,2.54,5.28,2.54,8.3v155.42c0,3.01-.89,5.94-2.54,8.3l-4.39,6.29h-48.83l-4.39-6.29c-1.64-2.35-2.54-5.28-2.54-8.3v-155.42c0-3.02.89-5.94,2.54-8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 452.19,
    y: 308.52,
    width: 48.83,
    height: 184.59,
    transform: "translate(953.21 801.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 452.19,
    y: 491.81,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 452.19,
    y: 489.03,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 452.19,
    y: 485.72,
    width: 5.86,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 452.19,
    y: 481.69,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 452.19,
    y: 476.98,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 452.19,
    y: 471.81,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 452.19,
    y: 466.02,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 452.19,
    y: 459.87,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 452.19,
    y: 453.09,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 452.19,
    y: 446.01,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 452.19,
    y: 438.5,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 452.19,
    y: 430.7,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 452.19,
    y: 422.69,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 452.19,
    y: 414.47,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 452.19,
    y: 406.24,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 452.19,
    y: 308.52,
    width: 5.86,
    height: 1.31,
    transform: "translate(910.24 618.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 452.19,
    y: 310.9,
    width: 5.86,
    height: 1.71,
    transform: "translate(910.24 623.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 452.19,
    y: 313.95,
    width: 5.86,
    height: 1.96,
    transform: "translate(910.24 629.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 452.19,
    y: 317.57,
    width: 5.86,
    height: 2.38,
    transform: "translate(910.24 637.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 452.19,
    y: 321.86,
    width: 5.86,
    height: 2.79,
    transform: "translate(910.24 646.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 452.19,
    y: 326.78,
    width: 5.86,
    height: 3.05,
    transform: "translate(910.24 656.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 452.19,
    y: 332.15,
    width: 5.86,
    height: 3.46,
    transform: "translate(910.24 667.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 452.19,
    y: 338.1,
    width: 5.86,
    height: 3.67,
    transform: "translate(910.24 679.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 452.19,
    y: 344.67,
    width: 5.86,
    height: 3.88,
    transform: "translate(910.24 693.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 452.19,
    y: 351.44,
    width: 5.86,
    height: 4.19,
    transform: "translate(910.24 707.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 452.19,
    y: 358.8,
    width: 5.86,
    height: 4.34,
    transform: "translate(910.24 721.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 452.19,
    y: 366.31,
    width: 5.86,
    height: 4.63,
    transform: "translate(910.24 737.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 452.19,
    y: 374.32,
    width: 5.86,
    height: 4.63,
    transform: "translate(910.24 753.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 452.19,
    y: 382.34,
    width: 5.86,
    height: 4.83,
    transform: "translate(910.24 769.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 452.19,
    y: 390.56,
    width: 5.86,
    height: 4.83,
    transform: "translate(910.24 785.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 452.19,
    y: 398.44,
    width: 5.86,
    height: 4.76,
    transform: "translate(910.24 801.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 495.16,
    y: 491.81,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 495.16,
    y: 489.03,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 495.16,
    y: 485.72,
    width: 5.86,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 495.16,
    y: 481.69,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 495.16,
    y: 476.98,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 495.16,
    y: 471.81,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 495.16,
    y: 466.02,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 495.16,
    y: 459.87,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 495.16,
    y: 453.09,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 495.16,
    y: 446.01,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 495.16,
    y: 438.5,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 495.16,
    y: 430.7,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 495.16,
    y: 422.69,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 495.16,
    y: 414.47,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 495.16,
    y: 406.24,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 495.16,
    y: 308.52,
    width: 5.86,
    height: 1.31,
    transform: "translate(996.18 618.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 495.16,
    y: 310.9,
    width: 5.86,
    height: 1.71,
    transform: "translate(996.18 623.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 495.16,
    y: 313.95,
    width: 5.86,
    height: 1.96,
    transform: "translate(996.18 629.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 495.16,
    y: 317.57,
    width: 5.86,
    height: 2.38,
    transform: "translate(996.18 637.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 495.16,
    y: 321.86,
    width: 5.86,
    height: 2.79,
    transform: "translate(996.18 646.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 495.16,
    y: 326.78,
    width: 5.86,
    height: 3.05,
    transform: "translate(996.18 656.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 495.16,
    y: 332.15,
    width: 5.86,
    height: 3.46,
    transform: "translate(996.18 667.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 495.16,
    y: 338.1,
    width: 5.86,
    height: 3.67,
    transform: "translate(996.18 679.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 495.16,
    y: 344.67,
    width: 5.86,
    height: 3.88,
    transform: "translate(996.18 693.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 495.16,
    y: 351.44,
    width: 5.86,
    height: 4.19,
    transform: "translate(996.18 707.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 495.16,
    y: 358.8,
    width: 5.86,
    height: 4.34,
    transform: "translate(996.18 721.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 495.16,
    y: 366.31,
    width: 5.86,
    height: 4.63,
    transform: "translate(996.18 737.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 495.16,
    y: 374.32,
    width: 5.86,
    height: 4.63,
    transform: "translate(996.18 753.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 495.16,
    y: 382.34,
    width: 5.86,
    height: 4.83,
    transform: "translate(996.18 769.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 495.16,
    y: 390.56,
    width: 5.86,
    height: 4.83,
    transform: "translate(996.18 785.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 495.16,
    y: 398.44,
    width: 5.86,
    height: 4.76,
    transform: "translate(996.18 801.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 457.02,
    y: 308.52,
    width: 39.17,
    height: 184.59,
    transform: "translate(953.21 801.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M488.67,326.02l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M479.22,326.02l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M469.76,326.02l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M460.31,326.02l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M689.99,518.32l-27.09-21.79h-277.59v-48.27c0-13.61-11.03-24.64-24.64-24.64H59.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h223.6c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h232.21v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-299.83ZM317.49,591.85h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM340.96,589.3c-3.45-3.87-6.88-8.18-10.21-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM562.53,599.98c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.32,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M689.99,518.32l-27.09-21.79h-277.59v-48.27c0-13.61-11.03-24.64-24.64-24.64H59.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h223.6c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h232.21v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-299.83ZM317.49,591.85h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM340.96,589.3c-3.45-3.87-6.88-8.18-10.21-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM562.53,599.98c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.32,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M261.18,532.91c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM261.18,670.91c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M353.48,626.52v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.81-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM261.18,670.91c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.18,541.45c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM261.18,670.91c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M311.06,632.05c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-155",
    cx: 261.18,
    cy: 623.81,
    r: 31.07,
    transform: "translate(-215.15 143.74) rotate(-22.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M261.18,573.16c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM261.18,671.42c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M261.18,566.33c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM261.18,673.69c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M311.06,632.05c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M261.18,571.73c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM261.18,672.77c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-153",
    cx: 261.18,
    cy: 623.81,
    r: 18.8,
    transform: "translate(-364.6 367.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "263.65 644.93 259.48 644.93 257.4 648.55 259.48 652.16 263.65 652.16 265.74 648.55 263.65 644.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M263.61,648.55c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "277.86 637 274.91 639.95 275.99 643.98 280.02 645.06 282.97 642.11 281.89 638.08 277.86 637"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M280.39,639.58c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "282.3 621.34 282.3 625.51 285.91 627.6 289.53 625.51 289.53 621.34 285.91 619.25 282.3 621.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M285.91,621.38c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "274.36 607.13 277.31 610.08 281.34 609 282.42 604.97 279.47 602.02 275.44 603.1 274.36 607.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M276.95,604.6c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "258.71 602.69 262.88 602.69 264.96 599.08 262.88 595.47 258.71 595.47 256.62 599.08 258.71 602.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M258.74,599.08c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "244.5 610.63 247.45 607.68 246.37 603.65 242.34 602.57 239.39 605.52 240.47 609.55 244.5 610.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M241.97,608.05c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "240.06 626.29 240.06 622.12 236.45 620.03 232.83 622.12 232.83 626.29 236.45 628.37 240.06 626.29"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-162",
    cx: 236.45,
    cy: 624.2,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "247.99 640.5 245.04 637.55 241.02 638.63 239.94 642.66 242.89 645.61 246.92 644.53 247.99 640.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M245.41,643.02c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-154",
    cx: 261.18,
    cy: 623.81,
    r: 13.3,
    transform: "translate(-364.6 367.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 533.29,
    y: 532.36,
    width: 190.9,
    height: 102.68,
    rx: 3.98,
    ry: 3.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 545.22,
    y: 622.47,
    width: 30.55,
    height: 18.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 555.98,
    y: 528.74,
    width: 9.04,
    height: 110.64,
    rx: 3.62,
    ry: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M560.5,639.38h0c-1.6,0-2.89-1.29-2.89-2.89v-104.85c0-1.6,1.3-2.89,2.89-2.89h0c1.6,0,2.89,1.29,2.89,2.89v104.85c0,1.6-1.29,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 613.46,
    y: 622.47,
    width: 30.55,
    height: 18.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M627.84,528.74h1.81c2,0,3.62,1.62,3.62,3.62v103.41c0,2-1.62,3.62-3.62,3.62h-1.81c-2,0-3.62-1.62-3.62-3.62v-103.41c0-2,1.62-3.62,3.62-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M628.74,639.38h0c-1.6,0-2.89-1.29-2.89-2.89v-104.85c0-1.6,1.3-2.89,2.89-2.89h0c1.6,0,2.89,1.29,2.89,2.89v104.85c0,1.6-1.3,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 681.71,
    y: 622.47,
    width: 30.55,
    height: 18.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 692.46,
    y: 528.74,
    width: 9.04,
    height: 110.64,
    rx: 3.62,
    ry: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M696.98,639.38h0c-1.6,0-2.89-1.29-2.89-2.89v-104.85c0-1.6,1.3-2.89,2.89-2.89h0c1.6,0,2.89,1.29,2.89,2.89v104.85c0,1.6-1.3,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M648.87,532.19h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M673.27,532.19c0,4.71-5.46,8.52-12.2,8.52s-12.2-3.82-12.2-8.52,5.46-8.52,12.2-8.52,12.2,3.82,12.2,8.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-189",
    cx: 661.07,
    cy: 530.54,
    rx: 10.48,
    ry: 6.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1122.22,598.18l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 985.07,
    cy: 623.81,
    r: 39.87,
    transform: "translate(31.77 1295.18) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1128.96,670.28c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-45.37-.81-56.86h-3.32v57.23c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1100.7,623.81h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1094.46,623.81h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M985.06,532.91c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM985.06,670.91c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1077.36,626.52v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM985.06,670.91c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M985.06,541.45c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM985.06,670.91c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M985.06,566.33c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM985.06,673.69c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M985.06,571.73c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM985.06,671.91c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M985.03,573.33c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM952.26,591.26c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM944.22,634.25c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM963.53,660.06c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM984.9,577.63c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM985.16,670.05c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1006.53,587.63c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1017.8,656.43c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM1025.84,633.99c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M1035.07,617.24c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM959.9,598.9c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM984.9,588.43c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM1021.06,602.16c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M949.86,603c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM984.9,577.63c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M985.03,573.33c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM952.26,591.26c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM944.22,634.25c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM963.53,660.06c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM984.9,577.63c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM985.16,670.05c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1006.53,587.63c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1017.8,656.43c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM1025.84,633.99c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "987.53 644.93 983.36 644.93 981.28 648.55 983.36 652.16 987.53 652.16 989.62 648.55 987.53 644.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M987.49,648.55c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "1001.74 637 998.79 639.95 999.87 643.98 1003.9 645.06 1006.85 642.11 1005.77 638.08 1001.74 637"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1004.27,639.58c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "1006.18 621.34 1006.18 625.51 1009.79 627.6 1013.41 625.51 1013.41 621.34 1009.79 619.25 1006.18 621.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1009.79,621.38c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "998.24 607.13 1001.19 610.08 1005.22 609 1006.3 604.97 1003.35 602.02 999.32 603.1 998.24 607.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1000.83,604.6c.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "982.59 602.69 986.76 602.69 988.84 599.08 986.76 595.47 982.59 595.47 980.5 599.08 982.59 602.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M982.62,599.08c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "968.38 610.63 971.33 607.68 970.25 603.65 966.22 602.57 963.27 605.52 964.35 609.55 968.38 610.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M965.85,608.05c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "963.94 626.29 963.94 622.12 960.33 620.03 956.71 622.12 956.71 626.29 960.33 628.37 963.94 626.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M960.33,626.25c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "971.87 640.5 968.92 637.55 964.89 638.63 963.82 642.66 966.77 645.61 970.79 644.53 971.87 640.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M969.29,643.02c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 985.06,
    cy: 623.81,
    r: 18.8,
    transform: "translate(-152.59 879.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M998.24,623.81c0,7.28-5.9,13.18-13.18,13.18s-13.18-5.9-13.18-13.18,5.9-13.18,13.18-13.18,13.18,5.9,13.18,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1090.4,571.44c5.24,10.56,8.91,22.04,10.71,34.12.32,2.15,2.12,3.77,4.29,3.77h14.06v-47.75h-23c-5.07,0-8.31,5.32-6.05,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1115.43,587.28h0c3.15,0,5.71,2.56,5.71,5.71v7.36c0,3.15-2.56,5.72-5.72,5.72h0c-1.45,0-2.62-1.17-2.62-2.62v-13.55c0-1.45,1.17-2.62,2.62-2.62Z",
    transform: "translate(2233.96 1193.34) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1119.17,
    y: 588.68,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1119.28,
    y: 589,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1117.46,
    y: 588.68,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1117.57,
    y: 589,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1115.75,
    y: 588.68,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1116.21,589h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1115.43,564.86h0c3.15,0,5.71,2.56,5.71,5.71v7.36c0,3.15-2.56,5.71-5.71,5.71h0c-1.45,0-2.62-1.17-2.62-2.62v-13.55c0-1.45,1.17-2.62,2.62-2.62Z",
    transform: "translate(2233.96 1148.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1119.69,566.26h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1119.28,
    y: 566.58,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1117.46,
    y: 566.26,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1117.57,
    y: 566.58,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1116.27,566.26h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1115.86,
    y: 566.58,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 1088.47,
    cy: 555.09,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M442.82,388.97v91.35h70.94v-91.35h-70.94ZM492.6,446.26c0,5.57-6.4,10.09-14.3,10.09s-14.3-4.52-14.3-10.09v-33.67c0-5.57,6.4-10.09,14.3-10.09s14.3,4.52,14.3,10.09v33.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M442.82,377.74v114.26h70.94v-114.26h-70.94ZM492.6,449.4c0,6.97-6.4,12.61-14.3,12.61s-14.3-5.65-14.3-12.61v-42.11c0-6.97,6.4-12.62,14.3-12.62s14.3,5.65,14.3,12.62v42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M442.82,372.26v129.54h70.94v-129.54h-70.94ZM492.6,453.5c0,7.9-6.4,14.3-14.3,14.3s-14.3-6.4-14.3-14.3v-47.74c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3v47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M459.15,492.4c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-189",
    cx: 453.33,
    cy: 492.4,
    r: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M509.08,492.4c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M507.37,492.4c0,2.27-1.84,4.11-4.11,4.11s-4.11-1.84-4.11-4.11,1.84-4.11,4.11-4.11,4.11,1.84,4.11,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M384.61,283.41h36.12v181.89c0,8.58-6.96,15.54-15.54,15.54h-20.58v-197.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M429.94,525.64h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M414.66,558.18h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 430.45,
    cy: 541.41,
    r: 34.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 430.45,
    cy: 541.41,
    r: 27.78,
    transform: "translate(-194.55 837.69) rotate(-76.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 430.45,
    cy: 541.41,
    r: 21.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 430.45,
    cy: 541.41,
    r: 17.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M248.49,315.96c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M84.88,356.1c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M122.51,259.7h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 271.8,
    y: 259.7,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M271.8,345.04v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M135.02,356.68l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.58c9.13-2.41,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 819.97,
    y: 523.67,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 484.44,
    y: 523.67,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 395.61,
    y: 580.17,
    width: 463.89,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 395.61,
    y: 582.28,
    width: 463.89,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 395.61,
    y: 584.75,
    width: 463.89,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 395.61,
    y: 621.74,
    width: 463.89,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 395.61,
    y: 623.85,
    width: 463.89,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 395.61,
    y: 626.32,
    width: 463.89,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3022.61,502.25h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3057.79,527.94h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 3058.43,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3058.54,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 3056.72,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3056.83,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 3055.01,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3055.12,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M3057.79,505.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.72v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 3058.43,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 3058.54,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 3056.72,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 3056.83,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 3055.01,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 3055.12,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 3030.67,
    y: 478.98,
    width: 15.99,
    height: 71.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 3038.66,
    y: 457.44,
    width: 15.99,
    height: 171.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 3038.66,
    y: 561.37,
    width: 15.99,
    height: 67.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 732.09,
    width: 2328.31,
    height: 484.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 738.99,
    y: 6,
    width: 2314.51,
    height: 472.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "743.33 8.79 3053.5 8.79 3053.5 6 739 6 739 478.98 743.33 478.98 743.33 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M369.51,163.76v297h45.89c10.55,0,19.1-8.55,19.1-19.1V163.76h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M369.51,163.76v297h45.89c10.55,0,19.1-8.55,19.1-19.1V163.76h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M358.16,163.76v291.78h45.89c10.55,0,19.1-8.4,19.1-18.76V163.76h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M369.51,217.34v243.41h28.1v-209.62c0-15.52-8.52-30.41-28.1-33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M366.41,217.13c-20.38-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM239.02,362.79c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "165.54 520.91 33.88 520.91 33.88 593.75 66.75 593.75 66.75 632.83 74.54 632.83 74.54 593.75 116.51 593.75 116.51 632.83 124.31 632.83 124.31 593.75 135.96 593.75 165.54 520.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "133.03 568.47 66.75 568.47 66.75 528.3 151.29 528.3 133.03 568.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M125.48,563.88h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 64.8,
    y: 626.25,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 64.8,
    y: 622.96,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M62.35,632.83H28.18c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M62.35,632.83H28.18c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M282.27,259.7h67.14c3.19,0,5.78,2.59,5.78,5.78v101.76c0,3.19-2.59,5.78-5.78,5.78h-67.14c-3.19,0-5.78-2.59-5.78-5.78v-101.76c0-3.19,2.59-5.78,5.78-5.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 278.8,
    y: 270.48,
    width: 74.08,
    height: 91.77,
    rx: 4.61,
    ry: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M366.41,217.13c-20.38-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM239.02,362.79c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M334.16,434.48c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,50.65.15,61.46.43v-6.3c-10.81-.28-50.42-.43-61.46-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M405.86,230.95l13.87-16.63c9.54-11.44,14.77-25.86,14.77-40.76v-23.52s-277.71,51.79-307.5,66.84c-29.79,15.04-26.66,15.7-26.66,15.7l290.14,5.55c5.94,0,11.58-2.64,15.38-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M127,198.23c-29.79,22.97-26.66,32.45-26.66,32.45l.2-.03c-.51,1.32-.2,1.95-.2,1.95h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.62c8.4-10.07,13.44-22.45,14.53-35.43l.23-.04V50.08S156.79,175.26,127,198.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M119.08,211.52c27.45-19.73,214.16-104.39,315.42-128.04v-33.4S156.79,175.26,127,198.23c-18.56,14.31-24.34,23.38-26.06,28.19,4.24-4.16,10.08-9.11,18.14-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M127,198.23c-29.79,22.97-26.66,32.45-26.66,32.45l.2-.03c-.51,1.32-.2,1.95-.2,1.95h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.62c8.4-10.07,13.44-22.45,14.53-35.43l.23-.04V50.08S156.79,175.26,127,198.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M127,211.34c-29.79,15.04-26.66,21.26-26.66,21.26h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.63c1.22-1.46,2.36-2.98,3.44-4.53v-89.68c0-4.61-4.05-3.45-8.62-2.86-69.32,8.97-262.38,86.92-287.56,99.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M238.74,435.37h-22.7c-4.52,0-8.19-3.67-8.19-8.19h0c0-4.52,3.67-8.19,8.19-8.19h22.7c4.52,0,8.19,3.67,8.19,8.19h0c0,4.52-3.67,8.19-8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 212.55,
    y: 423.62,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M213.45,430.75h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M239.83,423.62h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 213.97,
    y: 424.62,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M380.6,535.14c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M366.19,526.71v108.78c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M395.61,249.21H116.55c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h140.47c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M385.31,532.9c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.91,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 73.19,
    y: 502.67,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 74.32,
    y: 503.61,
    width: 18.45,
    height: 11,
    rx: 2.33,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 89.89,
    y: 504.66,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.08,
    y: 504.83,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 86.92,
    y: 504.66,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.11,
    y: 504.83,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 83.95,
    y: 504.66,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.14,
    y: 504.83,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 80.98,
    y: 504.66,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.17,
    y: 504.83,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 78.01,
    y: 504.66,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.2,
    y: 504.83,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 75.03,
    y: 504.66,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.23,
    y: 504.83,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M27.75,473.34h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M41.27,485.66c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M38.57,433.99c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M91.39,418.28c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM122.51,260.9c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M33.63,440.17h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M16.73,392.98c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M7.69,362.83c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M128.21,252.91h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.74-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-175",
    cx: 15.79,
    cy: 310.07,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M16.55,267.53h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M8.21,275.8h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1490.31,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1784.17,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2078.02,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1637.24,662.69h0c-1.99,0-3.61-1.62-3.61-3.61v-160.5c0-1.99,1.62-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1931.09,662.69h0c-1.99,0-3.61-1.62-3.61-3.61v-160.5c0-1.99,1.62-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1343.37,612.6h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1343.37,558.92h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1367.08,666.29h834.16c15.06,0,27.31-12.25,27.31-27.31v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,11.09-9.02,20.11-20.11,20.11h-834.16c-11.09,0-20.11-9.02-20.11-20.11v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,15.06,12.25,27.31,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2900.43,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(5832.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 2901.8,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5817.49 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2902.34,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5806.31 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2902.74,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5806.57 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2904.58,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5810.78 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2904.98,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5811.04 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2906.81,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5815.25 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2907.21,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5815.51 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2909.05,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5819.73 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2909.45,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5819.98 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2911.28,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5824.2 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2911.68,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5824.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2913.52,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5828.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2913.92,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5828.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 2916.49,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5846.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2917.03,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5835.69 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2917.43,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5835.95 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2919.73,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5840.16 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2919.67,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5840.42 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2921.5,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5844.64 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2921.9,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5844.89 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2923.74,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5849.11 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2924.14,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5849.36 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2925.97,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5853.58 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2926.37,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5853.83 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2928.21,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5858.05 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2928.61,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5858.31 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2186.33,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(4403.98 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2187.71,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4389.29 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2188.24,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4378.11 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2188.64,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4378.37 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2190.48,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4382.58 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2190.88,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4382.84 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2192.71,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4387.06 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2193.11,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4387.31 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2194.95,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4391.53 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2195.35,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4391.78 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2197.18,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4396 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2197.58,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4396.26 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2199.42,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4400.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2199.82,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4400.73 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 2202.4,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4418.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2202.93,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4407.49 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2203.33,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4407.75 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2205.17,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4411.97 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2205.57,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4412.22 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2207.4,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4416.44 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2207.8,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4416.69 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2209.64,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4420.91 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2210.04,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4421.17 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2211.88,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4425.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2212.28,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4425.64 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2214.11,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4429.85 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2214.51,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4430.11 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1472.23,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(2975.79 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1473.61,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(2961.09 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1474.14,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2949.92 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1474.54,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2950.17 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1476.38,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2954.39 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1476.78,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2954.64 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1478.61,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2958.86 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1479.01,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2959.11 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1480.85,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2963.33 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1481.25,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2963.59 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1483.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2967.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1483.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2968.06 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1485.32,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2972.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1485.72,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2972.53 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1488.3,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(2990.48 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1488.83,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2979.3 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1489.23,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2979.55 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1491.53,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(2983.77 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1491.47,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2984.02 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1493.31,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2988.24 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1493.7,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2988.5 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1495.54,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2992.71 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1495.94,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2992.97 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1497.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2997.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1498.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2997.44 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1500.01,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3001.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1500.41,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3001.91 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 758.13,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(1547.59 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 759.51,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1532.9 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 760.04,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1521.72 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 760.44,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1521.97 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M762.74,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(1526.19 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 762.68,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1526.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 764.52,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1530.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 764.92,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1530.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 766.75,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1535.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 767.15,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1535.39 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 768.99,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1539.6 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 769.39,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1539.86 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 771.22,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1544.08 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 771.62,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1544.33 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 774.2,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1562.28 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 774.73,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1551.1 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 775.13,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1551.36 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 776.97,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1555.57 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 777.37,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1555.83 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 779.21,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1560.04 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 779.61,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1560.3 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 781.44,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1564.51 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 781.84,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1564.77 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M784.14,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(1568.99 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 784.08,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1569.24 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 785.91,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1573.46 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 786.31,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1573.71 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1453.8,612.6h32.91v46.49h-32.91v7.2h73.42v-7.2h-33.29v-46.49h33.29v-7.19h-73.42v7.19ZM1339.77,638.98c0,15.06,12.25,27.31,27.31,27.31h13.3v-7.2h-13.3c-11.09,0-20.11-9.02-20.11-20.11v-26.38h33.41v-7.19h-40.61v33.57ZM2187.95,605.41v7.19h33.41v26.38c0,11.09-9.02,20.11-20.11,20.11h-13.3v7.2h13.3c15.06,0,27.31-12.25,27.31-27.31v-33.57h-40.61ZM1747.46,612.6h33.1v46.49h-33.1v7.2h73.42v-7.2h-33.1v-46.49h33.1v-7.19h-73.42v7.19ZM1600.63,612.6h33v46.48s0,0,0,0h-33v7.2h73.42v-7.2h-33.2s0,0,0,0v-46.48h33.2v-7.19h-73.42v7.19ZM2041.12,612.6h33.29v46.49h-33.29v7.2h73.42v-7.2h-32.91v-46.49h32.91v-7.19h-73.42v7.19ZM1894.29,612.6h33.2v46.48s0,0,0,0h-33.2v7.2h73.42v-7.2h-33s0,0,0,0v-46.48h33v-7.19h-73.42v7.19Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5AxSingleTridem);
export default __webpack_public_path__ + "static/media/5-Ax Single-Tridem.b6394c294bd6dc37456fd88324b1455c.svg";
export { ForwardRef as ReactComponent };